import { applyMiddleware, combineReducers, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistReducer, persistStore } from 'redux-persist'
import LocalStorage from 'redux-persist/lib/storage'

import commonCombinedReducer from '../../common/redux/reducers'

import accountCombinedReducer from '../../account/redux/reducers'
import allergenCombinedReducer from '../../allergens/redux/reducers'
import awardsCombinedReducer from '../../awards/redux/reducers'
import challengeCombinedReducer from '../../challenges/redux/reducers'
import courseTypesCombinedReducer from '../../course-types/redux/reducers'
import cuisineTypesCombinedReducer from '../../cuisine-types/redux/reducers'
import dictionaryWordsReducer from '../../dictionary-words/redux/reducers'
import dietsCombinedReducer from '../../diets/redux/reducers'
import dishTypesCombinedReducer from '../../dish-types/redux/reducers'
import foodMoodsCombinedReducer from '../../food-moods/redux/reducers'
import ingredientsCombinedReducer from '../../ingredients/redux/reducers'
import locationTypesCombinedReducer from '../../location-types/redux/reducers'
import usersCombinedReducer from '../../users/redux/reducers'

const rootReducer = combineReducers({
  common: commonCombinedReducer,
  allergens: allergenCombinedReducer,
  challenges: challengeCombinedReducer,
  foodMoods: foodMoodsCombinedReducer,
  account: persistReducer(
    {
      key: 'account',
      storage: LocalStorage,
      blacklist: ['login', 'updateUserSettings', 'refreshAccessToken'],
    },
    accountCombinedReducer,
  ),
  courseTypes: courseTypesCombinedReducer,
  cuisineTypes: cuisineTypesCombinedReducer,
  awards: awardsCombinedReducer,
  dishTypes: dishTypesCombinedReducer,
  ingredients: ingredientsCombinedReducer,
  diets: dietsCombinedReducer,
  locationTypes: locationTypesCombinedReducer,
  users: usersCombinedReducer,
  dictionaryWords: dictionaryWordsReducer,
})

const composeEnhancers = composeWithDevTools({})

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware()),
)

export const persistor = persistStore(store)
